export default "__VITE_ASSET__21fd299d__"